import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AdminLoginPage() {
  const { user, checking, login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a192f] text-[#efeade]">
        <Loader2 className="animate-spin" />
      </div>
    );
  }
  if (user) {
    const target = location.state?.from?.pathname || "/admin";
    return <Navigate to={target} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Identifiants invalides.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a192f] text-[#efeade] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <ShieldCheck size={20} strokeWidth={1.5} className="text-[#b08d57]" />
          <span className="text-[10px] tracking-[0.32em] uppercase text-[#b08d57]">
            Espace administrateur
          </span>
        </div>
        <h1 className="font-serif text-4xl md:text-5xl mb-2">Phénix · Back-office</h1>
        <p className="text-[#efeade]/60 text-sm mb-10">
          Accès réservé à l&apos;équipe du cabinet.
        </p>

        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="text-[10px] tracking-[0.28em] uppercase text-[#b08d57] block mb-2">
              E-mail
            </label>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full bg-transparent border border-[#efeade]/25 focus:border-[#b08d57] px-4 py-3 text-[#efeade] outline-none transition-colors"
              placeholder="admin@phenix-assurances.com"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.28em] uppercase text-[#b08d57] block mb-2">
              Mot de passe
            </label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full bg-transparent border border-[#efeade]/25 focus:border-[#b08d57] px-4 py-3 text-[#efeade] outline-none transition-colors"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <div
              data-testid="admin-login-error"
              className="text-sm text-[#f0b74e] border border-[#f0b74e]/30 bg-[#f0b74e]/10 px-4 py-3"
            >
              {error}
            </div>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-[#b08d57] text-[#0a192f] py-4 text-sm tracking-[0.28em] uppercase font-semibold hover:bg-[#f0b74e] transition-colors disabled:opacity-60"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
